import * as React from "react";
import { forwardRef } from "react";
const SvgFilter = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-list-filter-icon lucide-list-filter", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2 5h20" }), /* @__PURE__ */ React.createElement("path", { d: "M6 12h12" }), /* @__PURE__ */ React.createElement("path", { d: "M9 19h6" }));
const ForwardRef = forwardRef(SvgFilter);
export default ForwardRef;
